var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBallWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5109 16.1302L17.5109 16.1302L17.5105 16.1308C17.4025 16.316 17.4583 16.5545 17.6454 16.6641C17.7126 16.7053 17.7804 16.7209 17.8473 16.7209C17.982 16.7209 18.1069 16.6531 18.1793 16.5293C19.008 15.1526 19.4892 13.9686 19.7434 12.6974C19.7849 12.49 19.6503 12.2827 19.4376 12.2412C19.2302 12.1997 19.0229 12.3344 18.9814 12.5471L19.0305 12.5567L18.9815 12.5468C18.7435 13.7233 18.2944 14.8289 17.5109 16.1302Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4788 10.8333L13.4435 10.8687L13.4788 10.904L13.9578 11.383L13.9932 11.4184L14.0285 11.383L15.1526 10.259L15.1879 10.2236L15.1526 10.1882L14.6736 9.70924L14.6382 9.67388L14.6029 9.70924L13.4788 10.8333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82451 15.7273L4.78915 15.7627L4.82451 15.7981L5.30351 16.2771L5.33887 16.3124L5.37422 16.2771L6.49828 15.153L6.53364 15.1176L6.49828 15.0823L6.01928 14.6033L5.98393 14.5679L5.94857 14.6033L4.82451 15.7273Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17647 13.4587L8.21182 13.4233L8.17647 13.388L7.69746 12.909L7.66211 12.8736L7.62675 12.909L6.50269 14.033L6.46734 14.0684L6.50269 14.1038L6.9817 14.5828L7.01705 14.6181L7.05241 14.5828L8.17647 13.4587Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5544 10.091L11.5898 10.0557L11.5544 10.0203L11.0754 9.54131L11.04 9.50595L11.0047 9.54131L9.88062 10.6654L9.84527 10.7007L9.88062 10.7361L10.3596 11.2151L10.395 11.2504L10.4303 11.2151L11.5544 10.091Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86397 11.7771L9.89932 11.7417L9.86397 11.7063L9.38496 11.2273L9.34961 11.192L9.31425 11.2273L8.19019 12.3514L8.15484 12.3868L8.19019 12.4221L8.6692 12.9011L8.70455 12.9365L8.73991 12.9011L9.86397 11.7771Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.236 8.40059L13.2714 8.36523L13.236 8.32988L12.757 7.85088L12.7217 7.81552L12.6863 7.85088L11.5623 8.97494L11.5269 9.01029L11.5623 9.04565L12.0413 9.52465L12.0766 9.56L12.112 9.52465L13.236 8.40059Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9265 6.71455L14.9618 6.6792L14.9265 6.64384L14.4475 6.16484L14.4121 6.12949L14.3768 6.16484L13.2527 7.2889L13.2173 7.32426L13.2527 7.35961L13.7317 7.83861L13.7671 7.87397L13.8024 7.83861L14.9265 6.71455Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6081 5.02559L16.6435 4.99023L16.6081 4.95488L16.1291 4.47588L16.0938 4.44052L16.0584 4.47588L14.9343 5.59994L14.899 5.63529L14.9343 5.67065L15.4133 6.14965L15.4487 6.185L15.484 6.14965L16.6081 5.02559Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73759 17.5804L6.70224 17.6157L6.73759 17.6511L7.2166 18.1301L7.25195 18.1654L7.28731 18.1301L8.41137 17.006L8.44672 16.9707L8.41137 16.9353L7.93237 16.4563L7.89701 16.421L7.86166 16.4563L6.73759 17.5804Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41924 15.8914L8.38388 15.9268L8.41924 15.9621L8.89824 16.4411L8.93359 16.4765L8.96895 16.4411L10.093 15.3171L10.1284 15.2817L10.093 15.2463L9.61401 14.7673L9.57865 14.732L9.5433 14.7673L8.41924 15.8914Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7884 12.5237L11.753 12.5591L11.7884 12.5944L12.2674 13.0734L12.3027 13.1088L12.3381 13.0734L13.4621 11.9494L13.4975 11.914L13.4621 11.8787L12.9831 11.3997L12.9478 11.3643L12.9124 11.3997L11.7884 12.5237Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1067 14.2098L10.0714 14.2451L10.1067 14.2805L10.5857 14.7595L10.6211 14.7948L10.6564 14.7595L11.7805 13.6354L11.8159 13.6001L11.7805 13.5647L11.3015 13.0857L11.2662 13.0503L11.2308 13.0857L10.1067 14.2098Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1604 9.14873L15.1251 9.18408L15.1604 9.21944L15.6394 9.69844L15.6748 9.7338L15.7102 9.69844L16.8342 8.57438L16.8696 8.53902L16.8342 8.50367L16.3552 8.02467L16.3199 7.98931L16.2845 8.02467L15.1604 9.14873Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8509 7.46269L16.8155 7.49805L16.8509 7.5334L17.3299 8.01241L17.3652 8.04776L17.4006 8.01241L18.5247 6.88834L18.56 6.85299L18.5247 6.81763L18.0456 6.33863L18.0103 6.30328L17.9749 6.33863L16.8509 7.46269Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9508 4.02654L18.9508 4.0265C16.9588 2.04363 14.3132 0.95 11.5 0.95C8.66428 0.95 6.01413 2.04357 4.02662 4.02654L4.02658 4.02658C2.04355 6.00961 0.95 8.66431 0.95 11.5C0.95 14.3132 2.04363 16.9588 4.0265 18.9508L4.02654 18.9508C6.0185 20.9473 8.67317 22.05 11.5 22.05C14.3089 22.05 16.9545 20.9472 18.9508 18.9508C20.9472 16.9544 22.05 14.3043 22.05 11.5C22.05 8.67317 20.9473 6.0185 18.9508 4.02654ZM5.89992 19.5056L6.71665 18.6889L6.752 18.6535L6.71665 18.6182L6.23794 18.1395L6.20258 18.1041L6.16723 18.1395L5.27796 19.0287C4.79124 18.6278 4.34536 18.1779 3.94429 17.6948L4.80181 16.8373L4.83716 16.8019L4.80181 16.7666L4.3231 16.2879L4.28774 16.2525L4.25239 16.2879L3.46801 17.0722C3.35723 16.9133 3.25005 16.7481 3.14929 16.5795L16.575 3.15382C16.7431 3.25452 16.9052 3.36176 17.0673 3.47293L16.6221 3.91819L16.5867 3.95355L16.6221 3.9889L17.1008 4.46761L17.1361 4.50297L17.1715 4.46761L17.695 3.94412C18.1777 4.34072 18.6193 4.77818 19.0159 5.25651L18.5223 5.77989L18.4881 5.81623L18.5244 5.85054L19.0166 6.3157L19.053 6.35008L19.0873 6.31366L19.4929 5.88357C19.6021 6.03676 19.7052 6.19333 19.805 6.35334L6.35315 19.8052C6.1974 19.7094 6.04547 19.6105 5.89992 19.5056ZM1.72742 11.5C1.72742 6.11278 6.11278 1.72742 11.5 1.72742C13.0707 1.72742 14.5541 2.09773 15.8689 2.76107L2.7612 15.8687C2.10202 14.5539 1.72742 13.0705 1.72742 11.5ZM11.5 21.2726C9.90228 21.2726 8.39179 20.8846 7.05861 20.2031L20.2032 7.05848C20.8889 8.39157 21.2726 9.90209 21.2726 11.5C21.2726 16.8872 16.8872 21.2726 11.5 21.2726Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1209 17.8261C17.3356 17.8261 17.5096 17.652 17.5096 17.4373C17.5096 17.2227 17.3356 17.0486 17.1209 17.0486C16.9063 17.0486 16.7322 17.2227 16.7322 17.4373C16.7322 17.652 16.9063 17.8261 17.1209 17.8261Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallWhite);
export default __webpack_public_path__ + "static/media/ball-white.215934f6c2ec05eee73232a520bf48ba.svg";
export { ForwardRef as ReactComponent };